export enum DrawAction {
  Select = 'select',
  Rectangle = 'rectangle',
  Circle = 'circle',
  Scribble = 'freedraw',
  Arrow = 'arrow',
  Text = 'text',
}

export interface Note {
  id: string;
  text: string;
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
}
export interface Rectangle {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
  strokeWidth: number;
  lineStyle: 'solid' | 'dashed';
}

export interface Arrow {
  id: string;
  points: number[];
  color: string;
  strokeWidth: number;
}

export interface Scribble {
  id: string;
  points: number[];
  color: string;
  x?: number;
  y?: number;
  strokeWidth: number;
}

export interface Circle {
  id: string;
  x: number;
  y: number;
  radius: number;
  radiusX?: number;
  radiusY?: number;
  color: string;
  strokeWidth: number;
  lineStyle: 'solid' | 'dashed';
}

export interface Config {
  stroke: number;
  color: string;
  lineStyle: 'solid' | 'dashed';
}
